<div class="card transparent-card" [ngClass]="adClass">
    <div class="card-header" (click)="toggle()">
        <span class="card-title">
            <a role="button" [attr.aria-expanded]="show" [attr.aria-controls]="bodyID" [class.collapsed]="!show"
            class="d-flex justify-content-between align-items-center w-100">
                {{ title }}
                <i class="material-icons">
                    {{ show ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                </i>                  
            </a>
        </span>
    </div>
    <div [id]="bodyID" class="collapse" [class.show]="show" [attr.data-parent]="'#' + parent">
        <div class="card-body">
            <ng-content></ng-content>
        </div>
    </div>
</div>